// Module
var code = `<div class="alert">
  <span>
    <strong>DISCLAIMER:</strong> This form should be used to clear the system cache.
    Clearing cache is useful when a change was performed directly on the database
    (like changing a system property or asset counter). The operation in itself is not risky.
  </span>
</div>

<button
  type="submit"
  class=" btn btn-danger"
  ng-click="\$ctrl.execute()">
  Clear cache
</button>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/support/misc/clear-system-cache/misc-clear-system-cache.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;